<template>
	<div class="">
		<img style="height: 706px;position: absolute;top: 160px;z-index: -1;left: 0;right: 0;width: 100%;" src="@/assets/img/top_bg.png" alt="">
		<div class="text_c font_weight font_s24 p-30 main_color">学法在线平台</div>
		<div class="box-shadow mar_auto bgcolor_w radius6" style="width: 450px;padding: 30px 60px;">
			<div class="font_weight font_s20">登录</div>
			<br>
			<el-tabs v-model="loginType">
				<el-tab-pane label="密码登录" name="password">
					<el-form :model="ruleForm" status-icon ref="ruleForm" label-position="top" label-width="100px"
						class="demo-ruleForm">
						<el-form-item label="">
							<el-input prefix-icon="el-icon-user" v-model="ruleForm.account" placeholder="请输入姓名"
								maxlength="20"></el-input>
						</el-form-item>
						<el-form-item label="">
							<el-input prefix-icon="el-icon-lock" type="password" v-model="ruleForm.pass"
								placeholder="请输入密码" maxlength="20" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item>
							<el-col :span="14">
								<el-form-item>
									<el-input prefix-icon="el-icon-picture-outline" type="text" placeholder="点击图片可更换验证码"
										v-model="ruleForm.verify" maxlength="4" auto-complete="false"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<div class="text_c">
									<img :src="imgUrl" style="height: 41px;" @click="resetImg" />
								</div>
							</el-col>
						</el-form-item>
						<br>
						<el-form-item class="text_c">
							<el-button type="primary" round style="width: 300px;"
								@click="submitForm('ruleForm')">立即登录</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="验证码登录" name="sms">
					<el-form :model="smsForm" label-position="top" label-width="100px">
						<el-form-item label="">
							<el-input prefix-icon="el-icon-mobile-phone" v-model="smsForm.phone" placeholder="请输入手机号"
								maxlength="11"></el-input>
						</el-form-item>
						<el-form-item>
							<el-col :span="14">
								<el-form-item>
									<el-input prefix-icon="el-icon-message" v-model="smsForm.code" placeholder="请输入验证码"
										maxlength="6"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10">
								<div class="text_c">
									<el-button type="primary" plain :disabled="smsCooldown > 0 || smsSending"
										:loading="smsSending" @click="sendSmsCode" style="width: 100%;">
										{{ smsCooldown > 0 ? smsCooldown + 's后重发' : '获取验证码' }}
									</el-button>
								</div>
							</el-col>
						</el-form-item>
						<br>
						<el-form-item class="text_c">
							<el-button type="primary" round style="width: 300px;" :loading="smsLogging"
								@click="smsLoginFN">立即登录</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
			<div class="text_c m-t-10">
				<router-link to="/register">
					<span class="main_color line_bottom">还没有账号？点击前往注册></span>
				</router-link>
			</div>
			<div class="text_c m-t-10">
				<router-link to="/forgot">
					<span class="main_color line_bottom">忘记密码？</span>
				</router-link>
			</div>
			<div class="wechat-login-divider m-t-20">
				<span class="divider-line"></span>
				<span class="divider-text color_999 font_s12">其他登录方式</span>
				<span class="divider-line"></span>
			</div>
			<div class="text_c m-t-15">
				<div class="wechat-login-btn" @click="wechatLogin">
					<i class="el-icon-chat-dot-round" style="font-size: 28px; color: #07C160;"></i>
					<p class="font_s12 color_666 m-t-5">微信登录</p>
				</div>
			</div>
		</div>
		<el-dialog title="微信扫码登录" :visible.sync="wechatDialogVisible" width="400px" center @close="closeWechatDialog">
			<div v-if="!wechatBindRequired" class="text_c wechat-qrc-box" v-loading="wechatLoading">
				<img v-if="wechatQrcode" :src="wechatQrcode" alt="微信登录二维码" class="wechat-qrc-img">
				<p class="font_s14 color_666 m-t-15">{{ wechatStatusText }}</p>
				<el-button v-if="wechatLoginCode" class="m-t-15" size="small" plain @click="refreshWechatQrc">刷新二维码</el-button>
			</div>
			<div v-else class="wechat-bind-box">
				<div class="text_c m-b-20">
					<p class="font_s16 font_weight">绑定手机号</p>
					<p class="font_s13 color_999 m-t-5">该微信还未绑定系统账号，请用手机号验证码完成一次绑定。</p>
				</div>
				<el-form :model="wechatBindForm" label-position="top">
					<el-form-item>
						<el-input prefix-icon="el-icon-mobile-phone" v-model="wechatBindForm.phone" placeholder="请输入手机号" maxlength="11"></el-input>
					</el-form-item>
					<el-form-item>
						<el-row :gutter="10">
							<el-col :span="14">
								<el-input prefix-icon="el-icon-message" v-model="wechatBindForm.code" placeholder="请输入验证码" maxlength="6"></el-input>
							</el-col>
							<el-col :span="10">
								<el-button type="primary" plain :disabled="wechatBindCooldown > 0 || wechatBindSending"
									:loading="wechatBindSending" @click="sendWechatBindSms" style="width: 100%;">
									{{ wechatBindCooldown > 0 ? wechatBindCooldown + 's后重发' : '获取验证码' }}
								</el-button>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item class="text_c">
						<el-button type="primary" round style="width: 260px;" :loading="wechatBinding" @click="bindWechatPhone">完成绑定并登录</el-button>
					</el-form-item>
				</el-form>
				<div class="text_c">
					<el-button type="text" @click="refreshWechatQrc">重新扫码</el-button>
				</div>
			</div>
		</el-dialog>
		<br><br>
	</div>
</template>
<script>
	export default {
		name: "UserLogin",
		data() {
			return {
				loginType: 'password',
				imgUrl: "",
				ruleForm: {
					uniqid: "",
					account: "",
					verify: "",
					pass: "",
				},
				smsForm: {
					phone: "",
					code: "",
				},
				smsCooldown: 0,
				smsSending: false,
				smsLogging: false,
				smsTimer: null,
				wechatDialogVisible: false,
				wechatLoading: false,
				wechatQrcode: '',
				wechatLoginCode: '',
				wechatPollingTimer: null,
				wechatStatusText: '请使用微信扫描二维码完成登录',
				wechatBindRequired: false,
				wechatBindToken: '',
				wechatBindForm: {
					phone: '',
					code: '',
				},
				wechatBindSending: false,
				wechatBinding: false,
				wechatBindCooldown: 0,
				wechatBindTimer: null,
			};
		},
		activated() {
			this.resetImg();
		},
		beforeDestroy() {
			if (this.smsTimer) clearInterval(this.smsTimer);
			if (this.wechatBindTimer) clearInterval(this.wechatBindTimer);
			this.stopWechatPolling();
		},
		methods: {
			//刷新验证码
			resetImg() {
				this.$api.login.captcha({}).then((res) => {
					if (res.code == 1) {
						this.imgUrl = res.data.image;
						this.ruleForm.uniqid = res.data.uniqid;
					}
				}).catch(() => {}).finally(() => {})
			},
			//密码登录提交
			submitForm() {
				if (!this.ruleForm.account) {
					this.$message({
						message: '请输入登录账户',
						type: 'error'
					});
					return;
				}
				this.loginFN();
			},
			//密码登录接口
			loginFN() {
				const params = {
					account: this.ruleForm.account,
					verify: this.ruleForm.verify,
					uniqid: this.ruleForm.uniqid,
					password: this.ruleForm.pass,
				}
				this.$api.login.in(params).then((res) => {
					if (res.code == 1) {
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						localStorage.setItem('u_token', res.data.token.token);
						this.$router.push({
							path: '/Center',
						})
						location.reload();
					} else {
						this.resetImg();
						this.$message({
							message: res.info,
							type: 'error'
						});
					}
				}).catch(() => {}).finally(() => {})
			},
			//发送短信验证码
			sendSmsCode() {
				if (!this.smsForm.phone) {
					this.$message({
						message: '请输入手机号',
						type: 'error'
					});
					return;
				}
				if (!/^1[3-9]\d{9}$/.test(this.smsForm.phone)) {
					this.$message({
						message: '手机号格式不正确',
						type: 'error'
					});
					return;
				}
				this.smsSending = true;
				this.$api.login.sendSmsCode({
					phone: this.smsForm.phone
				}).then((res) => {
					if (res.code == 1) {
						this.$message({
							message: '验证码已发送',
							type: 'success'
						});
						this.smsCooldown = 60;
						this.smsTimer = setInterval(() => {
							this.smsCooldown--;
							if (this.smsCooldown <= 0) {
								clearInterval(this.smsTimer);
								this.smsTimer = null;
							}
						}, 1000);
					} else {
						this.$message({
							message: res.info || '发送失败',
							type: 'error'
						});
					}
				}).catch(() => {
					this.$message({
						message: '发送失败，请稍后重试',
						type: 'error'
					});
				}).finally(() => {
					this.smsSending = false;
				});
			},
			//微信授权登录
			wechatLogin() {
				this.wechatDialogVisible = true;
				this.refreshWechatQrc();
			},
			refreshWechatQrc() {
				this.stopWechatPolling();
				this.resetWechatBindState();
				this.wechatLoading = true;
				this.wechatQrcode = '';
				this.wechatLoginCode = '';
				this.wechatStatusText = '正在生成微信登录二维码...';
				this.$api.login.getWechatLoginQrc({ mode: 1 }).then((res) => {
					if (res.code == 1 && res.data && res.data.code && res.data.image) {
						this.wechatLoginCode = res.data.code;
						this.wechatQrcode = res.data.image;
						this.wechatStatusText = '请使用微信扫描二维码完成登录';
						this.startWechatPolling();
					} else {
						this.wechatStatusText = res.info || '微信登录二维码生成失败';
						this.$message.error(this.wechatStatusText);
					}
				}).catch(() => {
					this.wechatStatusText = '微信登录二维码生成失败，请检查后台微信配置';
				}).finally(() => {
					this.wechatLoading = false;
				});
			},
			startWechatPolling() {
				if (!this.wechatLoginCode) return;
				this.wechatPollingTimer = setInterval(() => {
					this.$api.login.queryWechatLogin({ code: this.wechatLoginCode }).then((res) => {
						if (res.code != 1 || !res.data || res.data.status === 'pending') return;
						if (res.data.status === 'success' && res.data.userinfo && res.data.userinfo.token) {
							this.stopWechatPolling();
							this.finishWechatLogin(res.data, '微信登录成功');
						}
						if (res.data.status === 'need_bind' && res.data.bind_token) {
							this.stopWechatPolling();
							this.wechatBindRequired = true;
							this.wechatBindToken = res.data.bind_token;
							this.wechatStatusText = '请完成手机号绑定';
						}
					}).catch(() => {});
				}, 2000);
			},
			stopWechatPolling() {
				if (this.wechatPollingTimer) {
					clearInterval(this.wechatPollingTimer);
					this.wechatPollingTimer = null;
				}
			},
			closeWechatDialog() {
				this.stopWechatPolling();
				this.resetWechatBindState();
			},
			resetWechatBindState() {
				this.wechatBindRequired = false;
				this.wechatBindToken = '';
				this.wechatBindForm = {
					phone: '',
					code: '',
				};
				this.wechatBindSending = false;
				this.wechatBinding = false;
				this.wechatBindCooldown = 0;
				if (this.wechatBindTimer) {
					clearInterval(this.wechatBindTimer);
					this.wechatBindTimer = null;
				}
			},
			validateWechatBindPhone() {
				if (!this.wechatBindForm.phone) {
					this.$message.error('请输入手机号');
					return false;
				}
				if (!/^1[3-9]\d{9}$/.test(this.wechatBindForm.phone)) {
					this.$message.error('手机号格式不正确');
					return false;
				}
				return true;
			},
			sendWechatBindSms() {
				if (!this.validateWechatBindPhone()) return;
				this.wechatBindSending = true;
				this.$api.login.sendSmsCode({
					phone: this.wechatBindForm.phone
				}).then((res) => {
					if (res.code == 1) {
						this.$message.success('验证码已发送');
						this.wechatBindCooldown = 60;
						this.wechatBindTimer = setInterval(() => {
							this.wechatBindCooldown--;
							if (this.wechatBindCooldown <= 0) {
								clearInterval(this.wechatBindTimer);
								this.wechatBindTimer = null;
							}
						}, 1000);
					} else {
						this.$message.error(res.info || '发送失败');
					}
				}).catch(() => {
					this.$message.error('发送失败，请稍后重试');
				}).finally(() => {
					this.wechatBindSending = false;
				});
			},
			bindWechatPhone() {
				if (!this.validateWechatBindPhone()) return;
				if (!this.wechatBindForm.code) {
					this.$message.error('请输入验证码');
					return;
				}
				if (!this.wechatBindToken) {
					this.$message.error('微信授权已过期，请重新扫码');
					this.refreshWechatQrc();
					return;
				}
				this.wechatBinding = true;
				this.$api.login.bindWechatPhone({
					phone: this.wechatBindForm.phone,
					code: this.wechatBindForm.code,
					bind_token: this.wechatBindToken
				}).then((res) => {
					if (res.code == 1 && res.data && res.data.userinfo && res.data.userinfo.token) {
						this.finishWechatLogin(res.data, '绑定成功，已登录');
					} else {
						this.$message.error(res.info || '绑定失败');
					}
				}).catch(() => {
					this.$message.error('绑定失败，请稍后重试');
				}).finally(() => {
					this.wechatBinding = false;
				});
			},
			finishWechatLogin(data, message) {
				localStorage.setItem('u_token', data.userinfo.token.token);
				if (data.openid) localStorage.setItem('wechat_openid', data.openid);
				this.wechatDialogVisible = false;
				this.$message({
					message: message,
					type: 'success'
				});
				this.$router.push({
					path: '/Center',
				});
				location.reload();
			},
			//短信验证码登录
			smsLoginFN() {
				if (!this.smsForm.phone) {
					this.$message({
						message: '请输入手机号',
						type: 'error'
					});
					return;
				}
				if (!this.smsForm.code) {
					this.$message({
						message: '请输入验证码',
						type: 'error'
					});
					return;
				}
				this.smsLogging = true;
				this.$api.login.smsLogin({
					phone: this.smsForm.phone,
					code: this.smsForm.code
				}).then((res) => {
					if (res.code == 1) {
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						localStorage.setItem('u_token', res.data.token.token);
						this.$router.push({
							path: '/Center',
						})
						location.reload();
					} else {
						this.$message({
							message: res.info || '登录失败',
							type: 'error'
						});
					}
				}).catch(() => {
					this.$message({
						message: '登录失败，请稍后重试',
						type: 'error'
					});
				}).finally(() => {
					this.smsLogging = false;
				});
			},
		}
	}
</script>
<style>
	.el-input__inner {
		border-bottom: 1px solid #DCDFE6;
		border-top: 0;
		border-right: 0;
		border-left: 0;
		border-radius: 0;
	}
	.wechat-login-divider {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.wechat-login-divider .divider-line {
		flex: 1;
		height: 1px;
		background: #E4E7ED;
	}
	.wechat-login-divider .divider-text {
		padding: 0 15px;
	}
	.wechat-login-btn {
		display: inline-block;
		cursor: pointer;
		padding: 10px 20px;
		border-radius: 8px;
		transition: background 0.3s;
	}
	.wechat-login-btn:hover {
		background: #f5f5f5;
	}
	.wechat-qrc-box {
		min-height: 230px;
	}
	.wechat-qrc-img {
		width: 210px;
		height: 210px;
		border: 1px solid #E4E7ED;
		border-radius: 4px;
	}
</style>
